import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function wholeNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    // Allow empty value (use Validators.required for required fields)
    if (value === null || value === undefined || value === '') {
      return null;
    }
    // Check if value is a whole number
    return Number.isInteger(+value) ? null : { notWholeNumber: true };
  };
}
